import React, { useMemo } from "react";

import InitialDataListPage from "../components/InitialDataListPage";

const ServiceAddrTypeMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
}) => {
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "8%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "ServiceAddr_Type_Name",
        header: "ประเภทอาคาร",
        width: "70%",
        align: "start",
        render: (item) => item.ServiceAddr_Type_Name || "-",
      },
      {
        key: "ServiceAddr_Type_Status",
        header: "สถานะ",
        width: "12%",
        align: "center",
        render: (item) =>
          item.ServiceAddr_Type_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "10%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#E13F57",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#E13F57";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#E13F57";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.ServiceAddr_Type_Name,
      item?.ServiceAddr_Type_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/serviceaddrtype"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "ประเภทอาคาร"}...`}
      fieldMappings={{ no: "ServiceAddr_Type_Id" }}
      getRowId={(item) => item?.ServiceAddr_Type_Id}
    />
  );
};

export default ServiceAddrTypeMain;
